import { useBillingStore } from '@/store/stores/billing'
import type { MultichatPlan } from '@/helpers/gcb2/multichat/types'

/** Catalog tariff ids (see TariffIntegrationsTable / billing). */
export const MULTICHAT_TARIFF_IDS = {
    /** Доктор Бот — Мультичат не входит в тариф */
    doctorBot: 'tariff1',
    /** Умный бот — Мультичат входит */
    smartBot: 'tariff2',
    /** Для профи — Мультичат входит */
    forPros: 'tariff3',
} as const

const PLANS_WITH_MULTICHAT = new Set<string>([
    MULTICHAT_TARIFF_IDS.smartBot,
    MULTICHAT_TARIFF_IDS.forPros,
])

function normalizeTariffFeatureId(raw?: string | null): string {
    return String(raw || '').trim()
}

/**
 * Resolves Multichat plan from the project's current billing tariff.
 * tariff1 → doctor_bot; tariff2 / tariff3 → smart_bot.
 */
export function resolveMultichatPlan(projectId?: string | null): MultichatPlan {
    if (!projectId) return 'doctor_bot'

    const billingStore = useBillingStore()
    const current = billingStore.getCurrentTariff(projectId) as
        | { integrationId?: string; extra?: { includesDhChat?: boolean } | null }
        | undefined

    if (!current?.integrationId) {
        return 'doctor_bot'
    }

    const catalog = billingStore.getTariffById(current.integrationId) as
        | { id?: string; baseTariffId?: string | null; extra?: { includesDhChat?: boolean } | null }
        | undefined

    const featureId = normalizeTariffFeatureId(
        catalog?.baseTariffId || current.integrationId || catalog?.id
    )

    if (PLANS_WITH_MULTICHAT.has(featureId)) {
        return 'smart_bot'
    }
    if (featureId === MULTICHAT_TARIFF_IDS.doctorBot) {
        return 'doctor_bot'
    }

    // Fallback for custom / renamed tariff rows
    if (current.extra?.includesDhChat || catalog?.extra?.includesDhChat) {
        return 'smart_bot'
    }

    return 'doctor_bot'
}

export function planIncludesMultichat(plan: MultichatPlan): boolean {
    return plan === 'smart_bot'
}
